import Vue from 'vue'

/**
 * @author José Luis R. <jose.ruiz@jbge.com.mx>
 *
 * Updates rejected photos from an affected
 *
 * @param  payload File and id
 * @return {Array} File's info
 */

const updateEvidencePhotos = (payload, nonConceptPhotos) =>
  !nonConceptPhotos
  ? Vue.$http.post('catalogs/common/replace/concept-file/', payload)
    : Vue.$http.put(`catalogs/common/replace/rescue_file/${nonConceptPhotos}/`, payload)
    .then()
    .catch((err) => {
      throw err
    })

export default updateEvidencePhotos



// WEBPACK FOOTER //
// ./src/services/workPlan/updateEvidencePhotos.js